import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react"; // Icon import
import "./supplierProfile.css";
import { ArrowLeft } from "lucide-react";



const SupplierProfile = () => {
  const navigate = useNavigate();

  // Retrieve user data from localStorage
  const userEmail = localStorage.getItem("supplierEmail") || "Not Available";
  const userBrand = localStorage.getItem("supplierBrand") || "Unknown Brand";

  // Same logout logic as your existing one
  const handleLogout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("supplierBrand");
    localStorage.removeItem("adminSelectedBrand");
    localStorage.removeItem("supplierEmail");
    localStorage.removeItem("currentView");

    // Optional resets if you had setBrand or setCurrentView in parent
    // (you can skip if not used in this component)
    // setBrand("");
    // setCurrentView("welcome");

    navigate("/login", { replace: true });
  };

  return (
    <div className="profile-page-container">
      <div className="profile-header"></div>
      <img
        src="/Images/temp.png"
        alt="Supplier Profile"
        className="profile-logo"
      />

      <h2 className="profile-name">{userBrand}</h2>

      <div className="profile-details">
        <p>
          <i className="fas fa-building"></i> <strong>Company:</strong> {userBrand}
        </p>
        <p>
          <i className="fas fa-envelope"></i> <strong>Email:</strong> {userEmail}
        </p>
 <button className="logout-btn" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
        <button className="back-button" onClick={() => navigate(-1)}>
  Go Back
</button>

      </div>
      
    </div>
  );
};

export default SupplierProfile;
